/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of BrandingsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfList_1OfUndetailedBrandingsResponse,
  SuccessResponse_1OfBrandingResponse,
  FileParameter,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockBrandings = [
  {
    id: 1,
    name: 'Default Branding',
    franchiseId: 1,
    primaryColors: {
      color950: '#0a2540',
      color900: '#0d47a1',
      color800: '#1565c0',
      color700: '#1976d2',
      color600: '#1e88e5',
      color500: '#2196f3',
      color400: '#42a5f5',
      color300: '#64b5f6',
      color200: '#90caf9',
      color100: '#bbdefb',
      color50: '#e3f2fd',
      color25: '#f1f8fe',
      contrastTextColor: '#ffffff',
    },
    secondaryColors: {
      color950: '#4a0013',
      color900: '#880027',
      color800: '#a8002f',
      color700: '#c70038',
      color600: '#dc004e',
      color500: '#f50057',
      color400: '#f73378',
      color300: '#f9669a',
      color200: '#fb99bb',
      color100: '#fdccdd',
      color50: '#feeeef',
      color25: '#fff7f8',
      contrastTextColor: '#ffffff',
    },
    logoImage: '',
    dashboardImage: '',
  },
  {
    id: 2,
    name: 'Dark Theme',
    franchiseId: 1,
    primaryColors: {
      color950: '#000000',
      color900: '#0a0a0a',
      color800: '#0f0f0f',
      color700: '#121212',
      color600: '#1a1a1a',
      color500: '#242424',
      color400: '#2e2e2e',
      color300: '#383838',
      color200: '#4a4a4a',
      color100: '#5c5c5c',
      color50: '#7a7a7a',
      color25: '#9e9e9e',
      contrastTextColor: '#ffffff',
    },
    secondaryColors: {
      color950: '#3e1f47',
      color900: '#6a1b9a',
      color800: '#7b1fa2',
      color700: '#8e24aa',
      color600: '#9c27b0',
      color500: '#ab47bc',
      color400: '#ba68c8',
      color300: '#ce93d8',
      color200: '#e1bee7',
      color100: '#f3e5f5',
      color50: '#f9f4fb',
      color25: '#fcfafd',
      contrastTextColor: '#ffffff',
    },
    logoImage: '',
    dashboardImage: '',
  },
  {
    id: 3,
    name: 'Vapiano Branding',
    franchiseId: 10,
    primaryColors: {
      color950: '#7A0F1E',
      color900: '#9B1425',
      color800: '#B5192C',
      color700: '#C91D34',
      color600: '#D4213D',
      color500: '#E03347',
      color400: '#E8586A',
      color300: '#F0808E',
      color200: '#F5A8B2',
      color100: '#FACDD4',
      color50: '#FDE8EC',
      color25: '#FEF4F6',
      contrastTextColor: '#ffffff',
    },
    secondaryColors: {
      color950: '#2D3D14',
      color900: '#3B5019',
      color800: '#4A6420',
      color700: '#536E24',
      color600: '#5C7A29',
      color500: '#6E8F35',
      color400: '#85A44E',
      color300: '#A2BA72',
      color200: '#C0D19C',
      color100: '#DAE5C3',
      color50: '#F0F4E8',
      color25: '#F7FAF3',
      contrastTextColor: '#ffffff',
    },
    logoImage: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyODAgODAiPjx0ZXh0IHg9IjE0MCIgeT0iNDUiIGZvbnQtZmFtaWx5PSJHZW9yZ2lhLCBzZXJpZiIgZm9udC1zaXplPSI0MCIgZm9udC13ZWlnaHQ9ImJvbGQiIGZvbnQtc3R5bGU9Iml0YWxpYyIgZmlsbD0iI0Q0MjEzRCIgdGV4dC1hbmNob3I9Im1pZGRsZSI+VkFQSUFOTzwvdGV4dD48dGV4dCB4PSIxNDAiIHk9IjY4IiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTAiIGZpbGw9IiNEMTIxM0QiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGxldHRlci1zcGFjaW5nPSIzIj5QQVNUQSAgfCAgUElaWkEgIHwgIEJBUjwvdGV4dD48L3N2Zz4=',
    dashboardImage: '',
  },
  {
    id: 4,
    name: 'Five Guys Branding',
    franchiseId: 11,
    primaryColors: {
      color950: '#640F13',
      color900: '#7E1317',
      color800: '#99171B',
      color700: '#B01C20',
      color600: '#C92027',
      color500: '#D93A40',
      color400: '#E25B60',
      color300: '#EB8285',
      color200: '#F3AAAC',
      color100: '#F8D1D2',
      color50: '#FDE7E8',
      color25: '#FEF3F4',
      contrastTextColor: '#ffffff',
    },
    secondaryColors: {
      color950: '#000000',
      color900: '#0A0A0A',
      color800: '#141414',
      color700: '#1A1A1A',
      color600: '#262626',
      color500: '#333333',
      color400: '#4D4D4D',
      color300: '#6B6B6B',
      color200: '#8F8F8F',
      color100: '#B8B8B8',
      color50: '#E0E0E0',
      color25: '#F5F5F5',
      contrastTextColor: '#ffffff',
    },
    logoImage: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyODAgODAiPjxyZWN0IHdpZHRoPSIyODAiIGhlaWdodD0iODAiIGZpbGw9IiNDOTIwMjciLz48dGV4dCB4PSIxNDAiIHk9IjQyIiBmb250LWZhbWlseT0iQXJpYWwgQmxhY2ssIEhlbHZldGljYSwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIzMiIgZm9udC13ZWlnaHQ9IjkwMCIgZmlsbD0iI0ZGRkZGRiIgdGV4dC1hbmNob3I9Im1pZGRsZSI+RklWRSBHVVlTPC90ZXh0Pjx0ZXh0IHg9IjE0MCIgeT0iNjQiIGZvbnQtZmFtaWx5PSJBcmlhbCwgSGVsdmV0aWNhLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEyIiBmaWxsPSIjRkZGRkZGIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBsZXR0ZXItc3BhY2luZz0iMiI+QlVSR0VSUyBBTkQgRlJJRVM8L3RleHQ+PC9zdmc+',
    dashboardImage: '',
  },
];

import { IBrandingsClient } from '../../interfaces';
export class BrandingsClientMocked implements IBrandingsClient {
  constructor(baseUrl?: string) {}

  async brandingsGETALL(cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfUndetailedBrandingsResponse> {
    await delay();
    return successResponse(mockBrandings) as SuccessResponse_1OfList_1OfUndetailedBrandingsResponse;
  }

  async brandingsGET(brandingId: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfBrandingResponse> {
    await delay();
    const branding = mockBrandings.find((b) => b.id === brandingId) || mockBrandings[0];
    return successResponse(branding) as SuccessResponse_1OfBrandingResponse;
  }

  async brandingsDELETE(brandingId: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockBrandings.findIndex((b) => b.id === brandingId);
    if (index > -1) {
      mockBrandings.splice(index, 1);
    }
  }

  async brandingsPOST(
    name?: string,
    franchiseId?: number,
    primaryColors_Color950?: string,
    primaryColors_Color900?: string,
    primaryColors_Color800?: string,
    primaryColors_Color700?: string,
    primaryColors_Color600?: string,
    primaryColors_Color500?: string,
    primaryColors_Color400?: string,
    primaryColors_Color300?: string,
    primaryColors_Color200?: string,
    primaryColors_Color100?: string,
    primaryColors_Color50?: string,
    primaryColors_Color25?: string,
    primaryColors_ContrastTextColor?: string,
    secondaryColors_Color950?: string,
    secondaryColors_Color900?: string,
    secondaryColors_Color800?: string,
    secondaryColors_Color700?: string,
    secondaryColors_Color600?: string,
    secondaryColors_Color500?: string,
    secondaryColors_Color400?: string,
    secondaryColors_Color300?: string,
    secondaryColors_Color200?: string,
    secondaryColors_Color100?: string,
    secondaryColors_Color50?: string,
    secondaryColors_Color25?: string,
    secondaryColors_ContrastTextColor?: string,
    logoFile?: FileParameter,
    dashboardFile?: FileParameter,
    cancelToken?: CancelToken
  ): Promise<void> {
    await delay();
    const defaultPrimaryColors = mockBrandings[0].primaryColors;
    const defaultSecondaryColors = mockBrandings[0].secondaryColors;
    
    mockBrandings.push({
      id: mockBrandings.length + 1,
      name: name || 'New Branding',
      franchiseId: franchiseId || 1,
      primaryColors: { ...defaultPrimaryColors },
      secondaryColors: { ...defaultSecondaryColors },
      logoImage: '',
      dashboardImage: '',
    });
  }

  async brandingsPATCH(
    id?: number,
    name?: string,
    franchiseId?: number,
    primaryColors_Color950?: string,
    primaryColors_Color900?: string,
    primaryColors_Color800?: string,
    primaryColors_Color700?: string,
    primaryColors_Color600?: string,
    primaryColors_Color500?: string,
    primaryColors_Color400?: string,
    primaryColors_Color300?: string,
    primaryColors_Color200?: string,
    primaryColors_Color100?: string,
    primaryColors_Color50?: string,
    primaryColors_Color25?: string,
    primaryColors_ContrastTextColor?: string,
    secondaryColors_Color950?: string,
    secondaryColors_Color900?: string,
    secondaryColors_Color800?: string,
    secondaryColors_Color700?: string,
    secondaryColors_Color600?: string,
    secondaryColors_Color500?: string,
    secondaryColors_Color400?: string,
    secondaryColors_Color300?: string,
    secondaryColors_Color200?: string,
    secondaryColors_Color100?: string,
    secondaryColors_Color50?: string,
    secondaryColors_Color25?: string,
    secondaryColors_ContrastTextColor?: string,
    logoFile?: FileParameter,
    dashboardFile?: FileParameter,
    cancelToken?: CancelToken
  ): Promise<void> {
    await delay();
    const branding = mockBrandings.find((b) => b.id === id);
    if (branding) {
      if (name) branding.name = name;
      // Note: primaryColor and secondaryColor params are simple strings,
      // but the branding structure now uses color objects.
      // In a real scenario, these would need to be color object updates.
    }
  }

  async allfranchisebranding(franchiseId: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfUndetailedBrandingsResponse> {
    await delay();
    const brandings = mockBrandings.filter((b) => b.franchiseId === franchiseId);
    return successResponse(brandings) as SuccessResponse_1OfList_1OfUndetailedBrandingsResponse;
  }

  async selectedfranchisebrandingGET(franchiseId: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfBrandingResponse> {
    await delay();
    const branding = mockBrandings.find((b) => b.franchiseId === franchiseId) || mockBrandings[0];
    return successResponse(branding) as SuccessResponse_1OfBrandingResponse;
  }

  async selectedfranchisebrandingPATCH(brandingId: number, franchiseId: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  // ====== Auto-generated stub methods ======

}